/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  margin-left: 10px;
  cursor: pointer;

  .field {
    height: 24px;
    background: #fff;
    padding: 3px 8px;
    margin-left: 1px;
    &.frist-field {
      border-radius: 4px 0px 0px 4px;
    }
    &.last-field {
      border-radius: 0px 4px 4px 0px;
    }
    &.complement {
      background: #e1e4e6;
    }
    label,
    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 13px;
      text-align: center;
      color: #5e6366;
    }
    label {
      font-weight: 600;
    }

    @media (max-width: 768px) {
      height: 20px;
      padding: 0 6px;
      background: transparent;
      &.frist-field {
        border-radius: 2px 0px 0px 2px;
      }
      &.last-field {
        border-radius: 0px 2px 2px 0px;
      }
      label,
      span {
        font-size: 10px;
        line-height: 12px;
        color: #fff;
      }
    }
  }
`;
